// tslint:disable-next-line: max-line-length
import { ExportLimitsDialogComponent } from '../../dialogs/export-limits-dialog/export-limits-dialog.component';
import {
  DataSource,
  CdkTable,
  CdkColumnDef,
  CdkHeaderCellDef,
  CdkHeaderCell,
  CdkCellDef,
  CdkCell,
  CdkHeaderRowDef,
  CdkHeaderRow,
  CdkRowDef,
  CdkRow,
} from '@angular/cdk/table';
import { Component, effect, inject, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { DataObject, IExportLimits } from '@miq/shared-models';
import { DialogService } from '@miq/platform';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { L10nTranslationModule } from 'angular-l10n';
import { TitleCasePipe } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
class ExportLimitsDataSource implements DataSource<IExportLimits> {
  constructor(private source$: Observable<IExportLimits[]>) {}
  public connect(): Observable<IExportLimits[]> {
    return this.source$;
  }
  public disconnect() {
    /**
     * Nothing to be done on disconnect.
     */
  }
}
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-export-limits',
  templateUrl: './export-limits.component.html',
  styleUrl: './export-limits.component.scss',
  imports: [
    L10nTranslationModule,
    CdkTable,
    CdkColumnDef,
    CdkHeaderCellDef,
    CdkHeaderCell,
    CdkCellDef,
    CdkCell,
    MatIconButton,
    MatIcon,
    MatTooltip,
    CdkHeaderRowDef,
    CdkHeaderRow,
    CdkRowDef,
    CdkRow,
    TitleCasePipe
],
})
export class ExportLimitsComponent implements OnInit {
  public exportLimits = input<IExportLimits[]>([]);
  public isReadyOnly = input(false);
  public isCatalogBased = input(false);
  public entityDisplayInfo = input<DataObject>();
  submitEvent = output<IExportLimits>();
  private readonly dataSubject = signal<IExportLimits[]>([]);
  public exportLimitsDataSource = new ExportLimitsDataSource(toObservable(this.dataSubject));
  public displayedColumns = [
    'availability',
    'lease',
    'sale',
    'portfoliosale',
    'property',
    'tim',
    'company',
    'contact',
    'tenancy',
    'brand',
    'space',
    'activity',
    'actions',
  ];
  private readonly notificationService = inject(DialogService);
  constructor() {
    effect(() => {
      if (this.entityDisplayInfo() != null && this.isCatalogBased()) {
        this.displayedColumns = this.displayedColumns.filter(element => {
          return this.entityDisplayInfo()[element];
        });
      }
    });
    effect(() => {
      const limits = this.exportLimits();
      if (limits) {
        this.dataSubject.set(limits);
      }
    });
  }
  public ngOnInit() {
    this.dataSubject.set(this.exportLimits());
  }
  public openEditDialog() {
    this.openDialog(this.exportLimits()[0])
      .pipe(filter(editedExportLimits => !!editedExportLimits))
      .subscribe(editedExportLimits => {
        /*
         * After emitting new export limits, component won't
         * refresh the table until this.editedExportLimits has
         * changed (received an ok from the database).
         */
        this.submitEvent.emit(editedExportLimits);
      });
  }
  /**
   * Open dialog and return dialog reference.
   *
   * @param exportLimits Optional record parameter to edit.
   * @return Dialog reference.
   */
  private openDialog(exportLimits: IExportLimits): Observable<IExportLimits> {
    return this.notificationService.openDialog(ExportLimitsDialogComponent, exportLimits, {
      panelClass: 'table-modals',
    });
  }
}
